module.exports = __webpack_public_path__ + "static/media/mic.2d56c780.png";